export const firstNamePool = ['Oliver', 'Amelia', 'George', 'Harry', 'Sophia', 'Ella', 'Freddie', 'Mia', 'Jack'];
export const lastNamePool = ['Smith', 'Johnson', 'Williams', 'Jones', 'Brown', 'Davis', 'Miller', 'Wilson'];
export const genderPool = ['male', 'female'];
